module.exports = __webpack_public_path__ + "img/Bettpickel.993e746b.svg";